module.exports = __webpack_public_path__ + "static/img/rank-first.c9962ed3.png";